import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { IInfoRowProps } from './InfoRow.types';

import './InfoRow.styles.scss';

const { Text } = Typography;

const InfoRow = ({
  title,
  value = '—',
  minWidthTitle = 150,
  minWidthValue = 150,
  className = '',
  ...props
}: IInfoRowProps) => {
  const { t } = useTranslation();

  const isValueString = typeof value == 'string';
  const isValueNumber = typeof value == 'number';

  return (
    <div className={`np-info-row ${className}`} {...props}>
      <div className="np-info-row__title" style={{ minWidth: minWidthTitle }}>
        {typeof title === 'string' ? <Text strong>{t(title)}:</Text> : title}
      </div>

      <div className="np-info-row__value" style={{ minWidth: minWidthValue }}>
        {isValueString || isValueNumber ? <Text>{isValueNumber ? value : t(value)}</Text> : value}
      </div>
    </div>
  );
};

export default InfoRow;
